import { get, put } from 'services/http';

const getEmbeddingConfiguration = () => get('/studio/api/embedding/configuration');

const replaceEmbeddingConfiguration = embeddingConfiguration =>
  put('/studio/api/embedding/configuration', embeddingConfiguration);

export default { getEmbeddingConfiguration, replaceEmbeddingConfiguration };
